module.exports = __webpack_public_path__ + "static/img/jquery.7add4891.png";